import validateSpanishID from '@/helpers/validateSpanishID'

export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    if (!args || args.length < 1) return false
    return validateSpanishID(value, args[0])
  }
}
